import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${BACKEND}/api`, withCredentials: true });

export const fileUrl = (id, w) => `${BACKEND}/api/files/${id}${w ? `?w=${w}` : ""}`;

export const errMsg = (e, fallback) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg).join(", ");
  return fallback;
};

export const digits = (n) => {
  const d = (n || "").replace(/\D/g, "");
  return d.length === 10 ? `91${d}` : d;
};
export const telLink = (n) => `tel:+${digits(n)}`;
export const waLink = (n, text) => `https://wa.me/${digits(n)}${text ? `?text=${encodeURIComponent(text)}` : ""}`;
export const shopUrl = (slug, lang = "en") => `${window.location.origin}${lang === "en" ? "" : `/${lang}`}/s/${slug}`;
export const shareUrl = (slug, lang = "en") => `${window.location.origin}/api/share/${slug}${lang === "en" ? "" : `?lang=${lang}`}`;
export const absFile = (id) => `${window.location.origin}/api/files/${id}`;
export const formatPrice = (p) => `₹${Number(p).toLocaleString("en-IN")}`;
